import { Media } from 'components/UI/V3/MediaViewer/MediaViewer';
import styles from 'components/UI/V3/MediaViewer/Player/MediaViewerPlayer.module.scss';
import React from 'react';

interface MediaViewerPlayerProps {
    media: Media;
}

export const MediaViewerPlayer: React.FC<MediaViewerPlayerProps> = ({ media }) => {
    const [videoThumbnail, setVideoThumbnail] = React.useState<string | undefined>(undefined);

    React.useEffect(() => {
        if (media.type !== 'video') {
            return;
        }

        const video = document.createElement('video');
        video.muted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.crossOrigin = 'anonymous';
        video.src = media.src;

        const onLoadedData = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (!ctx) {
                return;
            }

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

            const dataURL = canvas.toDataURL('image/png');
            setVideoThumbnail(dataURL);
        };

        video.addEventListener('loadeddata', onLoadedData);
        video.load();

        return () => {
            video.removeEventListener('loadeddata', onLoadedData);
            video.src = '';
        };
    }, [media.src]);

    return (
        <div className={styles.root}>
            {media.type === 'image' && (
                <img
                    src={media.src}
                    alt={media.type}
                    className={styles.media}
                />
            )}

            {media.type === 'video' && (
                <video
                    controls
                    playsInline
                    disablePictureInPicture
                    disableRemotePlayback
                    preload="metadata"
                    src={media.src}
                    poster={videoThumbnail}
                    className={styles.media}
                />
            )}
        </div>
    );
};
